import { HandCoins, Info } from "lucide-react";
import { PAYMENT_NOTE } from "@/lib/api";

export function PaymentNote({ className = "" }) {
  return (
    <p className={`flex gap-2 rounded-2xl bg-slate-50 p-3 text-base text-slate-700 ${className}`} data-testid="payment-note">
      <Info className="mt-0.5 h-5 w-5 shrink-0 text-orange-500" /> {PAYMENT_NOTE}
    </p>
  );
}

export default function PriceInput({ type, price, onChange }) {
  const opt = (value, label) => (
    <button type="button" onClick={() => onChange({ price_type: value, price: value === "valor" ? price : "" })} data-testid={`price-option-${value}`}
      className={`min-h-[60px] flex-1 rounded-2xl border-2 px-4 text-lg font-bold transition-colors ${type === value ? "border-orange-500 bg-orange-500 text-white" : "border-slate-300 text-slate-700 hover:border-orange-400"}`}>
      {label}
    </button>
  );
  const n = Number(price);
  const invalid = type === "valor" && price !== "" && (n < 10 || n > 20000);
  return (
    <div>
      <p className="po-label flex items-center gap-2"><HandCoins className="h-6 w-6 text-orange-500" /> Valor</p>
      <div className="flex gap-3">{opt("a_combinar", "A combinar")}{opt("valor", "Tenho um valor")}</div>
      {type === "valor" && (
        <div className="mt-3">
          <div className="relative">
            <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg font-bold text-slate-600">R$</span>
            <input inputMode="numeric" className="po-input pl-12" value={price} placeholder="150" aria-label="Valor em reais"
              onChange={(e) => onChange({ price_type: "valor", price: e.target.value.replace(/\D/g, "").slice(0, 5) })} data-testid="price-value-input" />
          </div>
          <p className={`mt-1 text-base ${invalid ? "font-semibold text-red-600" : "text-slate-600"}`} data-testid="price-hint">De R$ 10 a R$ 20.000.</p>
        </div>
      )}
    </div>
  );
}
